import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import DropDownMenu from '../DropDownMenu/DropDownMenu';
import Button from '../Button';
import getOpcoOptions from './helpers/getOpcoOptions';
import renderDropDownChildren from './helpers/renderDropDownChildren';
import LocationType from './LocationType';


const DropdownLookupForm = function DropdownLookupForm({
  content,
  programOptions,
  formValues,
  updateFormValues,
  submitForm,
}) {
  const { opcoDropdownLabel, ctaButtonLabel } = content;

  const selectedLocation = formValues.location;
  const locationWithType = programOptions
    .find(programOption => programOption.region === selectedLocation.region &&
      programOption.questionOptions);
  const locationTypeOptions = locationWithType ? locationWithType.questionOptions : null;

  return (
    <>
      {programOptions.length > 1 && (
        <DropDownMenu
          label={opcoDropdownLabel}
          labelClassName="opco-nav-form__field-label"
          list={getOpcoOptions(programOptions, updateFormValues)}
        >
          {renderDropDownChildren(selectedLocation.display)}
        </DropDownMenu>
      )}
      {!isEmpty(locationTypeOptions) && (
        <LocationType
          locationType={formValues.locationType}
          locationTypeOptions={locationTypeOptions}
          updateFormValues={updateFormValues}
          content={content}
        />
      )}
      <Button
        className="opco-nav-form__button"
        eventAction={submitForm}
        label={ctaButtonLabel}
      />
    </>
  );
};

DropdownLookupForm.propTypes = {
  content: PropTypes.shape({
    opcoDropdownLabel: PropTypes.string,
    ctaButtonLabel: PropTypes.string,
  }).isRequired,
  programOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  formValues: PropTypes.shape({
    location: PropTypes.shape({
      region: PropTypes.string,
      display: PropTypes.string,
    }),
    locationType: PropTypes.string,
  }).isRequired,
  updateFormValues: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
};

export default DropdownLookupForm;
